module.exports = __webpack_public_path__ + "img/sdg14.8de05e75.svg";